// extracted by mini-css-extract-plugin
module.exports = {"top-container":"style_top-container__3Z5AF","staff-card-container":"style_staff-card-container__2BeZS"};